import { useQuery, UseQueryOptions } from 'react-query'
import { posCheckoutBffClient } from 'src/config/data-access/axios'
import { ICourse } from 'src/types'

type GetProductsParams = {
    slug: string
    coupon?: string
    recurrence?: boolean
    boleto?: boolean
    isSanarPlus?: boolean
}

export const useGetProducts = (
    { slug = '', coupon, recurrence, boleto, isSanarPlus }: GetProductsParams,
    options?: UseQueryOptions<ICourse, any>
) => {
    const promoCode = coupon ? `&promoCode=${encodeURIComponent(coupon)}` : ''
    const recurrenceParam = recurrence ? '&recurrence=true' : ''
    const bankSlipParam = boleto ? '&bankSlip=true' : ''

    const regularPath = `v1/class?slug=${encodeURIComponent(
        slug
    )}${promoCode}${recurrenceParam}${bankSlipParam}`
    const sanarPlusPath = `v1/sanarplus?slug=${encodeURIComponent(
        slug.replace('sanarplus-mensal-', '')
    )}`

    const path = isSanarPlus ? sanarPlusPath : regularPath

    return useQuery<ICourse>(
        ['product', path, !!isSanarPlus],
        async () => {
            const { data } = await posCheckoutBffClient.get(path)
            return data
        },
        options
    )
}
